<template>
  <div>
    <banner title="关于沃时" text="沃时派客是国内领先的数字化包装管理创新平台" imgUrl="https://manybox.oss-cn-shanghai.aliyuncs.com/officialWebsite/banner3.png"></banner>
    <div class="box1">
      <div class="box">
        <div class="title">公司简介</div>
        <div class="subtitle">我们建设的一站式包装供应链数字化创新管理平台</div>
        <div class="contentBox">
          <div class="left">
            <img src="@/assets/company.png">
          </div>
          <div class="right">
            沃时派客是国内领先的数字化包装管理创新平台，我们致力于通过互联网技术，实现从方案设计、整合运营到包装物流的全链路工作流程的信息化和自动化，帮助企业供应链部门最大限度保证包装供应和包装总成本降低。平台在全国范围内拥有丰富的各类包装生产基地和ISTA认证实验室（Member ID: ST-10445 ），凭借数字化的包装管理能力、海量的包装数据库以及多终端的数据平台，收获了包括工业制造、机器人、医疗设备等各类不同领域客户的高度认可。
          </div>
        </div>
      </div>
    </div>
    <div class="box2">
      <div class="box">
        <div class="title">公司荣誉</div>
        <div class="subtitle">我们建设的一站式包装供应链数字化创新管理平台</div>
        <div>
          <el-carousel :interval="3500" indicator-position="outside" height="354px">
            <el-carousel-item v-for="item in imgList" :key="item">
              <img class="carouselImg" :src="item">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="box3">
      <div class="box">
        <div class="title">公司历程</div>
        <div class="subtitle">我们建设的一站式包装供应链数字化创新管理平台</div>
        <div class="contentBox">
          <div class="card" v-for="(item,index) in list" :key="index">
            <div class="year">{{item.year}}</div>
            <div class="info" v-for="(each,index2) in item.infoList" :key="index2">
              <div class="month">{{each.month}}</div>
              <div class="content">{{each.content}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import banner from '../banner.vue'

export default {
  components: {
    banner
  },
  data () {
    return {
      scrollTop: 0,
      imgList: [
        'https://manybox.oss-cn-shanghai.aliyuncs.com/officialWebsite/honor1.png',
        'https://manybox.oss-cn-shanghai.aliyuncs.com/officialWebsite/honor2.png',
        'https://manybox.oss-cn-shanghai.aliyuncs.com/officialWebsite/honor3.png'
      ],
      list: [
        {
          year: '2022',
          infoList: [
            { month: '8月', content: '参与的团标《循环包装选择使用的评价和计算方法》正式发布' },
            { month: '', content: '参与的团标《中空塑料板材循环包装容器》正式发布' },
            { month: '10月', content: '参与的团标《产品包装碳排放核算方法与规则》正式发布' },

          ]
        },
        {
          year: '2021',
          infoList: [
            { month: '3月', content: '成为上海出版印刷高等专科学校的“产学研创校企合作基地”' },
            { month: '4月', content: '沃时货运助手在应用市场上线' },
            { month: '', content: '沃时供应链助手（小程序）上线' },
            { month: '', content: '沃时包装助手（小程序）上线' },
            { month: '5月', content: '获上海市包装技术协会2020年度“科技创新培育企业”称号' },
            { month: '7月', content: '沃时云智造（MES）上线' },


          ]
        },
        {
          year: '2020',
          infoList: [
            { month: '4月', content: '首次通过ISO14001环境质量管理体系认证' },
            { month: '9月', content: '再次获得上海市创新创业大赛优胜企业奖,并获上海市科技型中小企业技术创新资金资助' },
            { month: '11月', content: '再次被认定为上海市高新技术企业（证书编号：GR202031002839）' },
            { month: '12月', content: '沃时派客数字化包装云平台（数据管理系统）正式启用' },
            { month: '', content: '获得上海市包装技术协会颁发的五星级企业（物流包装专业）' },
            { month: '', content: '被上海市包装技术协会评为“抗疫先进单位”' }

          ]
        },
        {
          year: '2019',
          infoList: [
            { month: '1月', content: '两个项目被认定为上海市高新技术成果转化项目（项目编号：201811652）' },
            { month: '5月', content: '沃时派客内部数据系统正式上线使用' },
            { month: '9月', content: '荣获中国包装行业科技技术奖三等奖（证书编号：2019-K-3-10-D01）' }
          ]
        }
        ,
        {
          year: '2018',
          infoList: [
            { month: '10月', content: '获得第七届中国创新创业大赛上海赛区暨2018“创业在上海”国际创新创业大赛优胜企业奖，并获上海市科技型中小企业技术创新资金资助' },
            { month: '12月', content: '获得第七届中国创新创业大赛国赛优秀企业奖（成长组）,并获上海市科技型中小企业技术创新资金资助' },
          ]
        },
        {
          year: '2017',
          infoList: [
            { month: '2月', content: '首次通过ISO9001质量管理体系认证' },
            { month: '5月', content: '“盒多多”在线定制商城上线' },
            { month: '11月', content: '被认定为上海市高新技术企业(证书编号:GR201731002062)' }
          ]
        }
        , {
          year: '2016',
          infoList: [
            { month: '5月', content: '沃时派客在线商城首次上线运营' },
          ]
        },

        {
          year: '2015',
          infoList: [
            { month: '11月', content: '公司正式成立' },
          ]
        }







      ]
    }
  },
  computed: {},
  created () {
  },
  mounted () {
    this.position()
  },
  watch: {
    '$route': function (to) {
      if (to.path == '/platform') {
        this.position()
      }
    }
  },
  methods: {
    position () {
      if (this.$route.query.anchorPoint == 'introduce') {
        this.animation(333)
      } else if (this.$route.query.anchorPoint == 'honor') {
        this.animation(939)
      } else if (this.$route.query.anchorPoint == 'experience') {
        this.animation(1582)
      }
    },
    animation (val) {
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.scrollTop < val) {
            let tmp = val - this.scrollTop
            this.scrollTop = this.scrollTop + (tmp > 100 ? 100 : tmp)
          }
          document.body.scrollTop = this.scrollTop
          document.documentElement.scrollTop = this.scrollTop
          this.scrollTop < val ? this.animation(val) : this.scrollTop = 0
        }, 10);
      })
    }
  }
}
</script>

<style lang='less' scoped>
.box1 {
  width: 100%;
  display: flex;
  justify-content: center;
  .box {
    width: 1200px;
    padding: 80px 0 54px 0;
    .title {
      font-size: 42px;
      font-weight: 500;
      text-align: center;
    }
    .subtitle {
      color: #999999;
      font-size: 16px;
      text-align: center;
      margin: 24px 0 65px 0;
    }
    .contentBox {
      display: flex;
      justify-content: space-between;
      .left {
        img {
          width: 503px;
          height: 300px;
        }
      }
      .right {
        width: 646px;
        color: #666666;
        line-height: 36px;
        font-size: 14px;
      }
    }
  }
}
.box2 {
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: #f7f8fb;
  .box {
    width: 1200px;
    padding: 56px 0 56px 0;
    .title {
      font-size: 42px;
      font-weight: 500;
      text-align: center;
    }
    .subtitle {
      color: #999999;
      font-size: 16px;
      text-align: center;
      margin: 24px 0 48px 0;
    }
  }
}
.box3 {
  width: 100%;
  display: flex;
  justify-content: center;
  .box {
    width: 1200px;
    padding: 56px 0 130px 0;
    .title {
      font-size: 42px;
      font-weight: 500;
      text-align: center;
    }
    .subtitle {
      color: #999999;
      font-size: 16px;
      text-align: center;
      margin: 24px 0 48px 0;
    }
    .contentBox {
      display: flex;
      justify-content: space-around;
      // height: 958px;
      padding-top: 100px;
      flex-wrap: wrap;
      align-content: space-around;
      background-image: url("../../../assets/lineTime.png");
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      line-height: 2;
      .center {
        img {
          width: 76px;
          height: 874px;
        }
      }
    }
  }
}
.card {
  background-color: #f7f7f7;
  border-radius: 40px;
  width: 428px;
  padding: 20px;
  margin-bottom: 50px;
  .year {
    font-weight: 700;
    font-size: 18px;
    width: 35px;
    margin-bottom: 5px;
    text-align: center;
    border-bottom: 2px solid #000;
  }
  .info {
    display: flex;
    .month {
      width: 35px;
      text-align: right;
      margin-right: 16px;
    }
    .content {
      flex: 1;
    }
  }
}
.card:nth-child(even) {
  margin-top: 40px;
}
.carouselImg {
  width: 100%;
  height: 100%;
}
</style>